import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";
import { DEX_EMBED, DEX_URL } from "../config";

export default function ChartSection() {
  return (
    <section id="chart" data-testid="chart-section" className="relative scroll-mt-28 py-24 sm:py-32">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-1/3 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-[#9945FF]/10 blur-[140px]" />
      </div>
      <div className="relative mx-auto max-w-6xl px-5">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
        >
          <p className="font-mono-x text-xs uppercase tracking-[0.35em] text-[#00F5D4]">Live Chart</p>
          <h2 className="mt-3 font-display text-3xl font-extrabold tracking-tight text-slate-50 sm:text-4xl lg:text-5xl">
            Straight from the <span className="text-[#FF2B4A]">North Pole</span> exchange
          </h2>
          <p className="mt-4 max-w-xl text-base text-slate-400">
            Watch $SOLMAS stuff stockings in real time. Powered by Dexscreener.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="relative mt-10"
        >
          <div className="absolute -inset-1 rounded-3xl bg-gradient-to-r from-[#FF2B4A]/40 via-[#9945FF]/30 to-[#00F5D4]/40 opacity-60 blur-lg" />
          <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-[#0F141C]">
            <iframe
              data-testid="dexscreener-chart-iframe"
              title="SOLMAS live chart on Dexscreener"
              src={DEX_EMBED}
              className="h-[520px] w-full md:h-[660px]"
              loading="lazy"
            />
          </div>
        </motion.div>

        <div className="mt-6 flex justify-center">
          <a
            data-testid="open-dexscreener-button"
            href={DEX_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-xl border border-white/10 bg-white/[0.04] px-6 py-3 font-display text-sm font-bold text-slate-200 transition-all duration-200 hover:border-[#00F5D4]/40 hover:text-[#00F5D4]"
          >
            Open on Dexscreener
            <ExternalLink className="h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
